import type { PackageManager } from '@cli-types/core-engine/utils.js'
import { isUnexpectedPnpmStoreError } from './is-unexpected-pnpm-store-error.js'
import { spawnAsync } from './spawn-async.js'

export async function runDependencyInstall(
  pm: PackageManager,
  args: string[],
  cwd: string,
  recovery: { attempted: boolean }
): Promise<void> {
  try {
    await spawnAsync(pm, args, cwd)
  } catch (error) {
    if (pm !== 'pnpm' || recovery.attempted || !isUnexpectedPnpmStoreError(error)) {
      throw error
    }

    recovery.attempted = true
    await spawnAsync('pnpm', ['install', '--force'], cwd)
    await spawnAsync(pm, args, cwd)
  }
}
